import { render, staticRenderFns } from "./warnRecordTable.vue?vue&type=template&id=4278ba20&scoped=true&"
import script from "./warnRecordTable.vue?vue&type=script&lang=js&"
export * from "./warnRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./warnRecordTable.vue?vue&type=style&index=0&id=4278ba20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278ba20",
  null
  
)

export default component.exports